import React, { useState } from "react";
// ANT DESIGN COMPONENTS
import { Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { updateLiftRefreshTable } from "../../../redux/lifts/liftSlice";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
// INTERFACES
import { RootState } from "../../../app/store";
// WIZARD COMPONENTS
import WizardExportButton from "../../setupWizard/components/WizardExportButton";
import WizardImportDialog from "../../setupWizard/components/WizardImportDialog";

function LiftsHeader() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [importOpen, setImportOpen] = useState(false);

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const { globalOrganizationId } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const handleReloadPage = () => {
    dispatch(updateLiftRefreshTable(true));
    setTimeout(() => {
      dispatch(updateLiftRefreshTable(false));
    }, 1000);
  };

  const handleImportSuccess = () => {
    handleReloadPage();
  };

  return (
    <div>
      <div className="generalStyles__pageHeader">
        {hasPermission(Permission.LiftsView, permissionSet ?? []) && (
          <div className="generalStyles__mlFix mt-1">
            <Button
              className="buttonStyle__8"
              icon={<FontAwesomeIcon icon={faArrowsRotate} className="generalStyles__mrFix" />}
              onClick={() => {
                handleReloadPage();
              }}
            >
              {t("edgeManagement.lifts.refreshTable")}
            </Button>
          </div>
        )}
        {hasPermission(Permission.LiftsView, permissionSet ?? []) && (
          <div className="generalStyles__mlFix mt-1">
            <Button
              icon={<UploadOutlined />}
              onClick={() => setImportOpen(true)}
              disabled={!globalOrganizationId}
            >
              Import
            </Button>
          </div>
        )}
        {hasPermission(Permission.LiftsView, permissionSet ?? []) && (
          <div className="generalStyles__mlFix mt-1">
            {/* StageLiftsFloors = 6 after StageChannelModifiers was inserted at 5. */}
            <WizardExportButton stage={6} orgId={globalOrganizationId || null} />
          </div>
        )}
      </div>
      {globalOrganizationId && (
        <WizardImportDialog
          orgId={globalOrganizationId}
          visible={importOpen}
          onClose={() => setImportOpen(false)}
          onSuccess={handleImportSuccess}
        />
      )}
    </div>
  );
}

export default LiftsHeader;
